import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { concatMap, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import {
  LabelOnboardingSuccess,
  CreateRecordLabelInvite,
} from '../action-creators';
import { LABEL_ONBOARDING_SUCCESS } from '../actions';
import AppState from '../../state';
import { CreateArtistInvite } from '../../artist/action-creators';

export const onboardingSuccessSendInvitesEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, LabelOnboardingSuccess>(LABEL_ONBOARDING_SUCCESS),
    withLatestFrom(state$),
    concatMap(([action, state]) => {
      return state.recordLabels.onboarding.artists.map((artist) => {
        if (artist.id) {
          return new CreateRecordLabelInvite(action.recordLabel.id, {
            artistId: artist.id,
            artistName: artist.name,
            artistAvatar: artist.avatar,
            inviter: action.recordLabel,
            contactType: artist.contact.type,
            address: artist.contact.value,
          });
        } else {
          return new CreateArtistInvite({
            type: 'record-label',
            artist: {
              name: artist.name,
            },
            invitee: artist.contact.value,
            contactType: artist.contact.type,
            inviter: action.recordLabel,
            songName: action.recordLabel.name as string,
            recordLabel: {
              id: action.recordLabel.id,
              name: action.recordLabel.name,
              plan: action.plan,
            },
          });
        }
      });
    })
  );
